// SHOW MAIL AND TEL

jQuery(document).ready(function($) {
  var tlMail = new TimelineMax({paused:true});
  var tlTel = new TimelineMax({paused:true});
 
  tlMail.to(".btn-actions", 0.5, {autoAlpha: 0, x:-10, display:"none", ease: Power3.easeOut}, "0.1")
        .fromTo(".store-mail-container", 0.5, {autoAlpha: 0, x:10, display:"none", ease: Power3.easeOut}, {autoAlpha: 1, x:0, display:"block", ease: Power3.easeOut}, "+=0.1");
 
  tlTel.to(".btn-actions", 0.5, {autoAlpha: 0, x:-10, display:"none", ease: Power3.easeOut}, "0.1")
        .fromTo(".store-tel-container", 0.5, {autoAlpha: 0, x:10, display:"none", ease: Power3.easeOut}, {autoAlpha: 1, x:0, display:"block", ease: Power3.easeOut}, "+=0.1");
 
  $('.btn-show-mail').on('click', function(e) {
    tlMail.timeScale(3).play();
  });
 
  $('.btn-show-tel').on('click', function(e) {
    tlTel.timeScale(3).play();
  });
 
  $('.close-mail-icon').on('click', function(e) {
    e.preventDefault();
    tlMail.timeScale(3).reverse();
    tlTel.timeScale(3).reverse();
  });
 
  //SHOW MAIL AND TEL WHEN THEY ARE COLUMNED
 
  var tlMailColumn = new TimelineMax({paused:true});
  var tlTelColumn = new TimelineMax({paused:true});
 
  tlMailColumn.to(".btn-show-mail-column", 0.5, {autoAlpha: 0, x:-10, display:"none", ease: Power3.easeOut}, "0.1")
              .fromTo(".store-mail-column-container", 0.5, {autoAlpha: 0, x:10, display:"none", ease: Power3.easeOut}, {autoAlpha: 1, x:0, display:"block", ease: Power3.easeOut}, "+=0.1");
 
  tlTelColumn.to(".btn-show-tel-column", 0.5, {autoAlpha: 0, x:-10, display:"none", ease: Power3.easeOut}, "0.1")
              .fromTo(".store-tel-column-container", 0.5, {autoAlpha: 0, x:10, display:"none", ease: Power3.easeOut}, {autoAlpha: 1, x:0, display:"block", ease: Power3.easeOut}, "+=0.1");
 
  if ( $(window).width() < 768 ) {
    $('.btn-show-mail-column').on('click', function(e) {
      tlMailColumn.pause(0);
      tlMail.timeScale(3).play(0);
    });
 
    $('.btn-show-tel-column').on('click', function(e) {
      tlTelColumn.pause(0);
      tlTel.timeScale(3).play(0);
    });
 
    $('.close-mail-icon-column').on('click', function(e) {
      e.preventDefault();
      tlMail.timeScale(3).reverse();
      tlTel.timeScale(3).reverse();
    });
  } else {
    $('.btn-show-mail-column').on('click', function(e) {
      tlMail.pause(0);
      tlMailColumn.timeScale(3).play(0);
    });
 
    $('.btn-show-tel-column').on('click', function(e) {
      tlTel.pause(0);
      tlTelColumn.timeScale(3).play(0);
    });
 
    $('.close-mail-icon-column').on('click', function(e) {
      e.preventDefault();
      tlMailColumn.timeScale(3).reverse();
      tlTelColumn.timeScale(3).reverse();
    });
  }
 
 $(window).resize(function() {
  if ( $(window).width() < 768 ) {
    $('.btn-show-mail-column').on('click', function(e) {
      tlMailColumn.pause(0);
      tlMail.timeScale(3).play(0);
    });
 
    $('.btn-show-tel-column').on('click', function(e) {
      tlTelColumn.pause(0);
      tlTel.timeScale(3).play(0);
    });
 
    $('.close-mail-icon-column').on('click', function(e) {
      e.preventDefault();
      tlMail.timeScale(3).reverse();
      tlTel.timeScale(3).reverse();
    });
  } else {
      $('.btn-show-mail-column').on('click', function(e) {
        tlMail.pause(0);
        tlMailColumn.timeScale(3).play(0);
      });
 
      $('.btn-show-tel-column').on('click', function(e) {
        tlTel.pause(0);
        tlTelColumn.timeScale(3).play(0);
      });
 
      $('.close-mail-icon-column').on('click', function(e) {
        e.preventDefault();
        tlMailColumn.timeScale(3).reverse();
        tlTelColumn.timeScale(3).reverse();
      });
  }
 });
})

